import Axios from "@app/api/axios";
import { ORDERS_API } from "@utils/constant";

export const deleteOrderDetails = (orderId) => {
  return Axios.delete(`${ORDERS_API}/${orderId}`);
};
